<p-panel
  *ngIf="job?.supplierId == supplierId || organisationTypeId == 1"
  styleClass="no-padding-panel overflow-hidden-panel panel-shadow"
>
  <p-header>
    <span class="panel-header">Carry-Over Authorisation</span>&nbsp;<i
      class="fa fa-info-circle"
      [escape]="false"
      pTooltip="A Carry-Over is where authorisation has been given<br>for a vehicle to be kept overnight between collection and delivery"
    ></i>
  </p-header>
  <div>
    <div style="max-height: 160px; overflow-y: auto">
      <p-table [value]="carryOverTasks" styleClass="no-border-table">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 110px; text-align: center">Vehicle Reg</th>
            <th style="text-align: left">Vehicle and Task Info</th>
            <th style="text-align: center">Approval Checks</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <ng-container *ngIf="typedTaskInfo(item) as data">
            <tr>
              <td class="carryover-cell" style="width: 110px">
                <span class="carry-over-vrm">{{ data.vehicle.registrationNumber }}</span>
              </td>
              <td style="vertical-align: middle; padding-left: 7px; padding-right: 7px">
                <app-carryover-task-info
                  [task]="data"
                  [taskSupplierScheduleStores]="taskSupplierScheduleStores"
                ></app-carryover-task-info>
              </td>
              <td>
                <div class="text-center">
                  <span *ngIf="data.preApproveCarryover">
                    <div *ngIf="loadingConditions">
                      <i class="fa fa-spin fa-spinner"></i>
                    </div>
                    <div
                      *ngIf="!loadingConditions"
                      class="p-2 cursor-pointer"
                      (click)="opConditions.show($event)"
                    >
                      <div *ngIf="!data.preApproveCarryover?.preApproveCarryover">
                        <span
                          class="rejected-text"
                          *ngIf="missingConditions(data.preApproveCarryover) == 1"
                          >1 failed check</span
                        >
                        <span
                          class="rejected-text"
                          *ngIf="missingConditions(data.preApproveCarryover) > 1"
                          >{{ missingConditions(data.preApproveCarryover) }} failed checks</span
                        >
                      </div>
                      <div *ngIf="data.preApproveCarryover?.preApproveCarryover">
                        <span
                          class="accepted-text"
                          *ngIf="data.preApproveCarryover?.preApproveCarryover == true"
                          >All checks passed</span
                        >
                      </div>
                      <i class="fa fa-info-circle text-gray-600"></i>

                      <p-overlayPanel
                        #opConditions
                        appendTo="body"
                        [dismissable]="true"
                        [showCloseIcon]="true"
                      >
                        <app-carryover-approval-analysis
                          [carryOverTask]="item"
                        ></app-carryover-approval-analysis>
                      </p-overlayPanel>
                    </div>
                  </span>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td [attr.colspan]="3">
              <div class="p-1 text-center text-gray-700">
                <i class="fa fa-info-circle"></i>
                Carryover authorisation has moved to the job screen.
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-panel>
